<template>
  <div id="login" class="login-container">
    <el-form ref="loginForm" :model="loginForm" :rules="loginRules" class="login-form" auto-complete="on" label-position="left">
        <div>
        <div class="title-container">
            <h2 class="title">
                <!-- <el-image class="icon" :src="iconUrl">
                </el-image> -->
                乐庭智慧养老可视化系统平台</h2>
        </div>
        <el-card class="box-card loginCard" :body-style='cardStyle'>
            <img :src="loginCenter">
            <div class="box_body">
                <el-row>
                    <el-col :span="24" style="padding-right:10px">
                        <div class="titles">
                            <span>欢迎登录</span>
                        </div>
                    </el-col>
                    <el-col :span="10" :offset='1' style="padding-right:10px;margin-top: 30px;">
                        <el-image style="width: 420px;height: 347px;" :src="url"></el-image>
                    </el-col>
                    <el-col :span="11" :offset='2' class="rightInput">
                        <!-- <div>
                            <p style="font-size:20px">欢迎登录</p >
                        </div> -->
                        <div style="width:100%">
                            <el-form-item prop="username">
                                <el-input placeholder="输入登录账号" ref="username" v-model="loginForm.username" name="username"
                                    type="text">
                                    <i slot="prefix" class="el-input__icon el-icon-user"></i>
                                </el-input>
                            </el-form-item>
                            <el-form-item prop="password">
                                <el-input placeholder="输入登录账号" ref="username" v-model="loginForm.password" name="password"
                                    type="text"
                                    show-password
                                    @keyup.enter.native="handleLogin">
                                    <i slot="prefix" class="el-input__icon el-icon-lock"></i>
                                </el-input>
                            </el-form-item>
                            <el-button :loading="loading" type="primary" style="width:100%;margin-bottom:30px;height:50px;font-size:20px" @click.native.prevent="handleLogin">登录</el-button>
                        </div>
                    </el-col>
                </el-row>
            </div>
        </el-card>
        </div>
    </el-form>
  </div>
</template>

<script>

    //import { validUsername } from '@/utils/validate'
    import loginCenter from '@/assets/loginCenter.png';
    export default {
        name: 'Login',
        data() {
            return {
                loginForm: {
                    username: '',
                    password: ''
                },
                loginRules: {
                    username: [{ required: true,message: '请输入登录账号', trigger: 'blur'}],
                    password: [{ required: true,message: '请输入密码', trigger: 'blur'}],
                },
                url:require('@/assets/leftlogin.png'),
                iconUrl:require('@/assets/icon.png'),
                loading: false,
                passwordType: 'password',
                cardStyle:'{border-radius:10px;padding:0;}',
                loginCenter:loginCenter,
            }
        },
        mounted(){
        },
        watch: {
        },
        methods: {
            handleLogin() {
                this.$refs.loginForm.validate(valid => {
                    if (valid) {
                        this.loading = true
                        this.$emit('handleLogin',this.loginForm)
                    } else {
                        console.log('error submit!!')
                        return false
                    }
                })
            }
        }
    }

</script>

<style lang="scss" scoped>
    $bg:#2d3a4b;
    $dark_gray:#889aa4;
    $light_gray:rgba(0, 228, 255, 1);

    .login-container {
        min-height: 100%;
        width: 100%;
        height: 100%;
        background-color: $bg;
        background-image: url(../../assets/loginBackground.jpg);
        background-size: cover;
        -webkit-background-size: cover;
        -o-background-size: cover;
        background-position: center 0;
        // overflow: hidden;
        .foot{
            position: fixed;
            color: white;
            text-align: center;
            width: 100%;
            top: 90vh;
        }
        .icon{
            height: 60px;
            width: 50px;
            margin-right: 10px;
            transform: translate(0px, 16px);
        }
        .el-card{
            border-radius:10px;
            background-color: transparent;
            border: 0;
        }
        .loginCard{
            position: relative;
            padding-bottom:20px ;
            img{
                width: 100%;
                height: 100%;
                position: absolute;
            }
            .box_body{
                position: relative;
                padding: 0 30px;
                .titles{
                    width: 100%;
                    text-align: center;
                    font-size: 30px;
                    color: $light_gray;
                    margin: 0px auto;
                    line-height: 50px;
                }
            }
            .rightInput{
                display: flex;
                align-items: center;
                padding-left:10px;
                padding-right:20px;
                margin-top: 30px;
                height: 350px;
            }
            /deep/ .el-input--prefix .el-input__inner {
                background: transparent;
                font-size: 20px;
                height: 55px;
                padding-left: 43px;
                border: 2px solid rgba(1, 128, 201, 1);
                color: white;
            }
            /deep/ .el-input__prefix {
                font-size: 20px;
                width: 40px;
                line-height: 52px;
                color: white;
            }
            /deep/ .el-input__suffix {
                font-size: 20px;
                width: 40px;
                line-height: 52px;
                color: white;
            }
            /deep/ .el-input .el-input__clear {
                color: white;
            }
        }
        ::-webkit-input-placeholder { /* WebKit browsers */
        color: #fff;
        font-size: 20px;
        }

        ::-moz-placeholder { /* Mozilla Firefox 19+ */
        color: #fff;
        font-size: 20px;
        }

        :-ms-input-placeholder { /* Internet Explorer 10+ */
        color: #fff;
        font-size: 20px;
        }
        .login-form {
            position: relative;
            width: 100%;
            height: 100%;
            max-width: 100%;
            // padding:  35px 0;
            /* margin: 0 auto; */
            overflow: hidden;
            display: flex;
            align-items: center;
            justify-content: center;
        }

        .tips {
            font-size: 14px;
            color: #fff;
            margin-bottom: 10px;

            span {
                &:first-of-type {
                    margin-right: 16px;
                }
            }
        }

        .svg-container {
            padding: 6px 5px 6px 15px;
            color: $dark_gray;
            vertical-align: middle;
            width: 30px;
            display: inline-block;
        }

        .title-container {
            position: relative;

            .title {
                font-size: 33px;
                color: $light_gray;
                margin: 0px auto 40px auto;
                text-align: center;
                font-weight: bold;
            }
        }

        // .show-pwd {
        //     position: absolute;
        //     right: 10px;
        //     top: 7px;
        //     font-size: 16px;
        //     color: $dark_gray;
        //     cursor: pointer;
        //     user-select: none;
        // }

        .thirdparty-button {
            position: absolute;
            right: 0;
            bottom: 6px;
        }

        @media only screen and (max-width: 470px) {
            .thirdparty-button {
                display: none;
            }
        }
    }
</style>
